import Moment from 'moment';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  AppDatePicker,
  AppFileUploader,
  AppRemixIcon,
  AppTextArea,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import AppInput from '../../../../../../components/form/AppInput';
import colors from '../../../../../../../constants/colors';
import minions from '../../../../../../../minions/minions';
import Translator from '../../../../../../components/helpers/Translator';

export default function GGCLEvidenceNewForm(props) {
  const { handleAddEvidence } = props;
  const addEvidenceValidationSchema = Yup.object().shape({
    evidenceName: Yup.string().required(
      ReactDOMServer.renderToString(<Translator file="user" name="user.required" />)
    ),
    evidenceDate: Yup.string().required(
      ReactDOMServer.renderToString(<Translator file="user" name="user.required" />)
    ),
  });

  return (
    <EvidenceForm>
      <Formik
        initialValues={{
          evidenceName: '',
          evidenceDescription: '',
          evidenceFiles: [],
          evidenceDate: Moment().format('DD/MM/YYYY'),
        }}
        validationSchema={addEvidenceValidationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleAddEvidence}
      >
        {({ handleSubmit, values, setFieldValue, isSubmitting, errors }) => (
          <div className="p-2">
            <h3>
              <Translator
                file="module-legalCompliance"
                name="add.new.evidence"
              />
            </h3>
            <AppInput
              title={<Translator file="module-legalCompliance" name="name" />}
              placeholder={
                ReactDOMServer.renderToString(<Translator
                  file="module-legalCompliance"
                  name="name.description.compulsory"
                />)
              }
              icon={<AppRemixIcon icon="double-quotes-l" noVariants />}
              value={values.evidenceName}
              onChange={(opt) => setFieldValue('evidenceName', opt)}
              error={errors.evidenceName}
              isClearable
            />
            <AppTextArea
              title={
                ReactDOMServer.renderToString(<Translator
                  file="module-legalCompliance"
                  name="module.lc.evidence.description"
                />)
              }
              placeholder={
                ReactDOMServer.renderToString(<Translator
                  file="module-legalCompliance"
                  name="name.description.compulsory"
                />)
              }
              icon={<AppRemixIcon icon="align-left" noVariants />}
              onChange={(opt) => setFieldValue('evidenceDescription', opt)}
              value={values.evidenceDescription}
            />
            <div className="row">
              <div className="col-lg-6">
                <AppDatePicker
                  title={
                    <Translator file="module-legalCompliance" name="date" />
                  }
                  value={values.evidenceDate}
                  onChange={(opt) => setFieldValue('evidenceDate', opt)}
                  popperClassName="react-datepicker-popper react-datepicker-popper-1000"
                />
              </div>
              <div className="col-lg-6">
                {values.evidenceFiles.length > 0 && (
                  <EvidenceFileList>
                    {values.evidenceFiles.map((f) => (
                      <li
                        key={f.name}
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="click.delete"
                          />
                        )}
                        onClick={() =>
                          setFieldValue(
                            'evidenceFiles',
                            values.evidenceFiles.filter(
                              (file) => file.name !== f.name
                            )
                          )
                        }
                      >
                        <AppRemixIcon
                          className="pointer mr-3"
                          icon="delete-bin"
                          color={colors.danger}
                        />
                        {minions.files.fileIcon(f.name, true, null, 'mr-2')}
                        {f.name}
                      </li>
                    ))}
                  </EvidenceFileList>
                )}
                <AppFileUploader
                  isMulti
                  placeholder={
                    values.evidenceFiles.length === 0
                      ? ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="select.one.multiple.files"
                          />
                        )
                      : ReactDOMServer.renderToString(
                          <Translator
                            file="general"
                            name="select.number.of.elements"
                            variables={{
                              elements: values.evidenceFiles.length,
                            }}
                          />
                        )
                  }
                  onChange={(opt) =>
                    setFieldValue('evidenceFiles', [
                      ...values.evidenceFiles,
                      ...opt,
                    ])
                  }
                  btnText={<Translator file="general" name="search..." />}
                />
              </div>
            </div>
            <span
              className={`btn btn-primary btn-xs float-right mt-2 mb-4${
                isSubmitting ? ' disabled' : ''
              }`}
              onClick={handleSubmit}
            >
              <Translator
                file="module-legalCompliance"
                name="create.evidence"
              />
            </span>
          </div>
        )}
      </Formik>
    </EvidenceForm>
  );
}

const EvidenceForm = styled.div`
  h3 {
    font-size: 13px;
    font-weight: bold;
  }
`;
const EvidenceFileList = styled.ul`
  list-style: none;
  margin: 10px 0 0 0;
  padding-left: 6px;
  overflow-y: auto;
  max-height: 113px;
  li {
    cursor: pointer;
    display: flex;
    align-items: center;
    border-top: 1px solid ${colors.grey300};
    padding: 8px 0;
    span {
      font-size: 12px;
      color: ${colors.primary};
    }
  }
  li:first-child {
    border-top: 0;
  }
`;
